import { useCallback, useMemo, useState } from 'react';

export default function useCapsLockWarning() {
  const [capsLockOn, setCapsLockOn] = useState(false);
  const [focused, setFocused] = useState(false);

  const updateFromEvent = useCallback((event) => {
    try {
      if (event && typeof event.getModifierState === 'function') {
        setCapsLockOn(Boolean(event.getModifierState('CapsLock')));
      }
    } catch (_) {
      // ignore
    }
  }, []);

  const onFocus = useCallback((event) => {
    setFocused(true);
    updateFromEvent(event);
  }, [updateFromEvent]);

  const onBlur = useCallback(() => {
    setFocused(false);
  }, []);

  const bind = useMemo(() => ({
    onKeyDown: updateFromEvent,
    onKeyUp: updateFromEvent,
    onFocus,
    onBlur,
  }), [onBlur, onFocus, updateFromEvent]);

  return {
    show: focused && capsLockOn,
    bind,
  };
}

